import { PersonStatus } from 'utils/enum';

export const canGoToDashboard = ({
  user,
  isAuthenticated,
  hasCompletedSecondaryOverview,
  isConsented,
}) => {
  return (
    isAuthenticated &&
    user?.email_verified &&
    hasCompletedSecondaryOverview &&
    isConsented
  );
};

export const getAuthorizedPaths = (secondaryOverviewPath) => {
  return ['/verify-email', '/consent', secondaryOverviewPath];
};

export const getRedirectPath = ({
  user,
  isConsented,
  secondaryOverviewPath,
  hasCompletedSecondaryOverview,
}) => {
  if (!user?.email_verified) {
    return '/verify-email';
  }

  if (!hasCompletedSecondaryOverview) {
    return secondaryOverviewPath;
  }

  if (!isConsented) {
    return '/consent';
  }

  return '';
};

export const isOnboardedUser = (person) => {
  return person?.status === PersonStatus.Onboarded;
};

export const MedicalInfo = 'medical-information';
export const ContactInfo = 'contact-information';
